import HelpCenterLayout from "@components/helpCenter/HelpCenterLayout"
import { ResultView, StoreLink } from "@components/helpCenter/ResultParts"
import { useTranslation } from "react-i18next"

export default function CancelationApplePage() {
  const { t } = useTranslation()

  return (
    <HelpCenterLayout>
      <ResultView
        icon="warning"
        title={t("pages.helpCenter.activeAppleSubscription")}
      >
        <p>{t("pages.helpCenter.cancelationApple.followAppleInstructions")}</p>

        <StoreLink url="https://support.apple.com/118428" />
      </ResultView>
    </HelpCenterLayout>
  )
}
